/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc
 */
import * as References from './CollectionsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc#getCollectionBySlug
 */
export const GET_COLLECTION_BY_SLUG_QUERY_FIELD_NAME = 'com_hubspot_marketplace_discovery_studio_rpc_CollectionsRpc_getCollectionBySlug';
export const GET_COLLECTION_BY_SLUG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COLLECTION_BY_SLUG_QUERY_FIELD_NAME,
  args: ['slug', 'offset', 'limit', 'filter', 'sorts'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCollectionBySlugRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc#getAllCollections
 */
export const GET_ALL_COLLECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_discovery_studio_rpc_CollectionsRpc_getAllCollections';
export const GET_ALL_COLLECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_COLLECTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAllCollectionsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});